import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { IParams } from '../model/http';
import { initItemsParams } from './channel.service';


export let invoiceTake = localStorage?.getItem('invoiceTake');

export const initListsParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};

export const initItemsInvoiceParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};

export interface IListsApiResponse {
  items?: any[];
  total?: number;
  size?: number;
  page?: number;
}

@Injectable({
  providedIn: 'root',
})
export class NovaPoshtaService {
  constructor(
    private readonly http: HttpClient,
  ) {
  }

  private readonly listsSubject$ = new BehaviorSubject<any>({});
  public readonly lists$ = this.listsSubject$.asObservable();

  private readonly itemsInvoicesSubject$ = new BehaviorSubject<any>({});
  public readonly itemsInvoices$ = this.itemsInvoicesSubject$.asObservable();

  private readonly itemsMyInvoicesSubject$ = new BehaviorSubject<any>({});
  public readonly itemsMyInvoices$ = this.itemsMyInvoicesSubject$.asObservable();

  private itemsMyInvoices: any;
  private pageSize!: number;

  public readonly isLoader$ = new BehaviorSubject<boolean>(false);

  public queryListsParams = {...initListsParams};
  public queryListInvoicesParams = {...initItemsInvoiceParams};


  // List Integration Nova Poshta
  private getAll(params: any) {
    return this.http.get<any>(environment.baseURL + '/np/all', {params})
      .pipe(map(v => v.data));
  }

  loadLists() {
    this.isLoader$.next(true);
    return this.getAll(this.queryListsParams)
      .pipe(tap((data) => {
        this.listsSubject$.next(data);
        this.isLoader$.next(false);
      }));
  }

  setQueryListsParams(params: IParams) {
    const {sort, order, search, take, page} = params;
    this.queryListsParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryListsParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryListsParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryListsParams.search,
      take: take || this.queryListsParams.take,
      page: page || this.queryListsParams.page,
    };
    return this.loadLists();
  }

  // List Invoices Nova Poshta

  private getInvoicesAll(params: any) {
    return this.http.get<any>(environment.baseURL + '/np/invoices/all', {params})
      .pipe(map(v => v.data));
  }

  private getAllMyInvoices(params: any) {
    return this.http.post<any>(environment.nova_poshta, {...params})
      .pipe(map(v => v));
  }

  loadListInvoices() {
    this.isLoader$.next(true);
    return this.getInvoicesAll(this.queryListInvoicesParams)
      .pipe(tap((data) => {
        this.itemsInvoicesSubject$.next(data);
        this.isLoader$.next(false);
      }));
  }

  loadListMyInvoices(api_key: string) {
    this.isLoader$.next(true);
    return this.getAllMyInvoices({
      apiKey: api_key,
      modelName: 'InternetDocument',
      calledMethod: 'getDocumentList',
      methodProperties: {
        DateTimeFrom: '01.01.2000',
        DateTimeTo: '01.01.2024',
        Page: '1',
        GetFullList: '1',
      },
    })
      .pipe(tap((v) => {
        this.itemsMyInvoices = {...v};
        this.itemsMyInvoicesSubject$.next({
          ...v,
          data: v.data.slice(0, initItemsInvoiceParams.take || 25),
          totalCount: v.data.length,
          pageSize: initItemsInvoiceParams.take || 0,
          pageIndex: initItemsInvoiceParams.page || 0,
        });
        this.isLoader$.next(false);
      }));
  }

  changeMyInvoicesSort(sortState: {
    active: string;
    direction: string;
  }) {
    const {active, direction} = sortState;

    const sortFunction = (a: any, b: any) => {
      const [valueA, valueB] = [a[active], b[active]];
      return valueA.localeCompare(valueB) * (direction === 'asc' ? 1 : -1);
    };

    const sortedData = [...this.itemsMyInvoices.data].sort(sortFunction);

    this.itemsMyInvoicesSubject$.next({
      ...this.itemsMyInvoices,
      data: this.pageSize ? sortedData.slice(0, this.pageSize) : sortedData.slice(0, 25),
      totalCount: sortedData.length,
    });
  }

  changeMyInvoicesPagination(paginationDetails: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  }) {
    this.pageSize = paginationDetails.pageSize;

    const start = Math.max(paginationDetails.pageIndex, 0) * paginationDetails.pageSize;
    const end = start + paginationDetails.pageSize;

    this.itemsMyInvoicesSubject$.next({
      ...this.itemsMyInvoices,
      data: this.itemsMyInvoices.data.slice(start, end - 1),
      totalCount: this.itemsMyInvoices.data.length,
    });
  }

  searchMyInvoices(searchedValue: string) {
    const filteredData = this.itemsMyInvoices.data.filter((item: any) => {
      return [item.Description, item.IntDocNumber, item.StateName, item.RecipientContactPerson, item.RecipientsPhone, item.AdditionalInformation].some(v => v.includes(searchedValue));
    });

    this.itemsMyInvoicesSubject$.next({
      ...this.itemsMyInvoices,
      data: this.pageSize ? filteredData.slice(0, this.pageSize) : filteredData.slice(0, 25),
      totalCount: filteredData.length,
    });
  }

  setQueryListInvoicesParams(params: IParams) {
    const {sort, order, search, take, page} = params;
    this.queryListInvoicesParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryListInvoicesParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryListInvoicesParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryListInvoicesParams.search,
      take: take || this.queryListInvoicesParams.take,
      page: page || this.queryListInvoicesParams.page,
    };
    return this.loadListInvoices();
  }


  addApiKey(payload: { title: string, api_key: string }) {
    return this.http.post(environment.baseURL + '/np/', payload);
  }

  removeApiKey(uuid: string) {
    return this.http.delete(environment.baseURL + `/np/${uuid}`);
  }

  checkApiKey(api_key: string) {
    return this.http.post(environment.nova_poshta, {
      apiKey: api_key,
      calledMethod: 'getCounterparties',
      methodProperties: {CounterpartyProperty: 'Sender'},
      modelName: 'Counterparty',
    });
  }

  getCabinets(search?: string) {
    const params: { search?: string } = {};
    if (search) {
      params.search = search.trim();
    }
    return this.http.get<any>(environment.baseURL + '/np/cabinets', {params})
      .pipe(map(v => v.data));
  }

  updateInvoiceTake() {
    invoiceTake = localStorage?.getItem('invoiceTake');
    initItemsParams.take = (invoiceTake && +invoiceTake) || 25;
  }

  createInvoice(payload: any) {
    return this.http.post(environment.baseURL + '/np/invoices', payload);
  }

  updateInvoice(id: string, payload: any) {
    return this.http.put(environment.baseURL + `/np/invoices/${id}`, payload);
  }

  deleteInvoice(uuid: string) {
    return this.http.delete(environment.baseURL + `/np/invoices/${uuid}`);
  }

  deleteBulk(ids: string[]): Observable<string[]> {
    const payload = {
      ids,
    };
    return this.http.patch<{ data: string[] }>(environment.baseURL + '/np/invoices/bulk/delete', payload).pipe(
      map((res) => res.data),
    );
  }

  postCall(params: any) {
    return this.http.post<any>(environment.nova_poshta, {...params})
      .pipe(map(v => v));
  }

  getTTNDetails(payload: any) {
    return this.http.post<any>(environment.baseURL + '/np/ttn', payload);
  }
}
